(function () {
  var SVG = '<span class="dirham-symbol" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 324.19 290.45" style="width:0.85em;height:0.85em;vertical-align:-0.1em;fill:currentColor;"><path d="M324.19,196l-11.564-6.936-35.262.109c-4.33,19.185-12.015,36.87-24.215,52.285-52.205,65.958-150.381,44.876-223.958,48.532,2.849-4.499,5.761-8.708,7.763-13.727,1.821-4.565,5.237-16.258,5.237-20.763v-67.5c-.733-.266-1.196,1-1.5,1h-17c-.439,0-5.271-1.443-6.211-1.789C3.818,182.177-1.094,165.349.2,152c2.935,2.677,10.64,8,14.49,8h27.5v-29h-19.5c-2.219,0-9.47-3.846-11.523-5.477C1.752,118.046-.644,105.426.2,94c2.717,2.386,10.046,8,13.49,8h28.5V35.5c0-3.807-3.689-16.654-5.239-20.761L29.199,0c1.487.774,2.749,1.006,4.438,1.053,53.694,1.484,121.79-8.11,171.229,12.77,37.763,15.949,63.968,47.84,72.42,88.078.965.826,21.558-.319,25.406.096,11.676,1.26,18.623,12.809,21.497,23.003v13c-2.88-1.425-8.525-7-11.5-7h-31.5c-.266.733,1,1.196,1,1.5v25c0,.35-1.774,1.109.5,2.5h22c1.226,0,6.431,3.176,7.826,4.174,6.946,4.973,8.988,11.078,11.674,18.826v13ZM229.19,102c-3.228-25.477-14.198-52.622-35.081-68.419-31.382-23.739-71.896-17.869-108.919-18.581v87h144ZM233.268,131H85.19v29h148.078v-29ZM227.69,189c-46.154,1.783-94.583,0-141,0-.304,0-.767-1.266-1.5-1v87c41.025.035,87.048,4.95,118.024-27.476,12.247-12.821,24.852-40.392,25.994-58.02.202-3.118-1.042-.523-1.518-.505Z"/></svg></span>';
  var PATTERN = /Dhs[. ]* *([\d,]+)(?:\.\d+)?/g;

  function replaceInNode(node) {
    if (node.nodeType === 3) {
      if (node.nodeValue.indexOf('Dhs') === -1) return;
      var wrapper = document.createElement('span');
      wrapper.innerHTML = node.nodeValue.replace(PATTERN, SVG + ' $1');
      node.parentNode.replaceChild(wrapper, node);
    } else if (
      node.nodeType === 1 &&
      node.tagName !== 'SCRIPT' &&
      node.tagName !== 'STYLE' &&
      !node.classList.contains('dirham-symbol')
    ) {
      Array.from(node.childNodes).forEach(replaceInNode);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    replaceInNode(document.body);
  });

  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (n) {
        if (n.nodeType === 1) replaceInNode(n);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
